export interface ParsedWireAction {
    method: 'post' | 'get';
    loadingRole: string;
    action: string;
    serializeSelector?: string
}

/**
 * :action?param1=112&param2=22
 * data-wire-submit="action?param=1&param=2"
 * data-wire-click="action?param=1&param=2"
 *
 * data-wire-click="POST(.selector):action?param=1&param=2"
 * data-wire-click="GET(.selector):action?param=1&param=2"
 *
 * @param attr
 * @protected
 */
export default function wireActionParse(eventType: string, attr: string): ParsedWireAction {

    if (attr.indexOf(":")> -1) {
        let splitted = attr.split(":");

        let action = splitted.pop();

        let method: 'post' | 'get' = eventType == 'submit' ? 'post' : 'get';
        let serializeSelector = '';

        for (const p of splitted) {

            let parsed = functionParse(p);

            if(parsed[0] == 'get' || parsed[0] == 'post'){
                method = parsed[0];
                serializeSelector = parsed[1];
            }

        }


        return {
            method: method,
            action: action,
            serializeSelector: serializeSelector,
            loadingRole: '',
        }
    }

    if (eventType == 'submit') {
        return {
            method: 'post',
            loadingRole: '',
            action: attr
        };
    }

    return {
        method: 'get',
        loadingRole: '',
        action: attr
    };

    //
    // let parts: string[];
    //
    // let sepIndex = attr.indexOf(":");
    //
    // if (attr.indexOf(":") > 0) {
    //
    //     let splitted = reverse(attr.split(":"));
    //
    //     let isGet = true;
    //     let postSelectorVal = '';
    //     let loadingTagVal = '';
    //     let fragmentTag = '';
    //
    //     let actionVal = splitted[1];
    //     let paramsVal = splitted[0];
    //
    //     if (splitted.length > 2) {
    //
    //         for (let i = 2; i < splitted.length; i++) {
    //             let v = splitted[i];
    //
    //             if(v.indexOf('@') === 0){
    //                 let httpmethod = v;
    //
    //                 if (httpmethod.indexOf('(') > 0) {
    //                     let halfs = splitInHalf('(', httpmethod);
    //                     let selector = halfs[1].replace(')', '');
    //
    //                     if (selector.trim().length > 0) {
    //                         postSelectorVal = selector.trim();
    //                     }
    //                 }
    //
    //                 if (httpmethod.indexOf('@post') >= 0) {
    //                     isGet = false;
    //                 }
    //             }
    //
    //             if(v.indexOf('#') === 0){
    //                 loadingTagVal = v.substr(1);
    //             }
    //
    //             if(v.indexOf('$') === 0){
    //                 fragmentTag = v.substr(1);
    //             }
    //
    //         }
    //
    //
    //
    //     } else {
    //
    //         if (eventType == 'submit') {
    //             isGet = false;
    //         }
    //
    //     }
    //
    //
    //     return {
    //         method: isGet ? 'get' : 'post',
    //         loadingTag: loadingTagVal,
    //         action: actionVal,
    //         params: paramsVal,
    //         fragmentTag: fragmentTag
    //     }
    //
    // } else {
    //     throw new Error("Bad formatted action: " + attr);
    // }

}

function reverse(arr: string[]): string[] {
    let n: string[] = [];

    arr.forEach(e => {
        n.unshift(e);
    });
    return n;
}

function functionParse(d: string): string[] {

    if (d.indexOf('(') > 0) {
        let func = splitInHalf('(', d);
        return [
            func[0].toLowerCase(),
            func[1].substring(0, func[1].length - 1)
        ];
    }

    return [d, ''];
}

function splitInHalf(char: string, s: string): string[] {

    let sepIndex = s.indexOf(char);

    if (!sepIndex) {
        return [s, ""];
    }

    return [
        s.slice(0, sepIndex),
        s.slice(sepIndex + 1)
    ];

}